module.exports = "/_next/static/images/pizza-08a8fa273f3c3d09f177bbe2ba2b7274.jpg";